import { Link, Flex, Text, Dialog, Button } from "@radix-ui/themes";
import React from "react";
import { EnvelopeClosedIcon } from "@radix-ui/react-icons";
import { InstagramLogoIcon } from "@radix-ui/react-icons";
import { DiscordLogoIcon } from "@radix-ui/react-icons";

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <Flex justify="between" align="center" style={styles.flexContainer}>
        {/* Left Section */}
        <Flex align="center" gap="5">
          <Text
            size="5"
            style={{
              fontFamily: "'Bungee Hairline', sans-serif",
              fontWeight: 600,
              fontStyle: "normal",
            }}
          >
            Tellos AI
          </Text>

          {/* Terms of service  */}
          <Dialog.Root>
            <Dialog.Trigger>
              <Link
                variant="ghost"
                style={{ color: "white", cursor: "pointer" }}
              >
                Terms of Service
              </Link>
            </Dialog.Trigger>

            <Dialog.Content maxWidth="950px">
              <Dialog.Title> Terms of Service of Tellos AI</Dialog.Title>

              <Flex direction="column" gap="3">
                <Text>Last Updated: February 27, 2025</Text>
                <Text>
                  Welcome to Tellos AI! These Terms of Service ("Terms") govern
                  your use of Tellos AI ("we," "our," or "us"). By accessing or
                  using our services, you agree to these Terms. If you do not
                  agree, please do not use our services.
                </Text>
                <Text>
                  <strong>1. Use of Services</strong>
                  <br />- You agree not to use Tellos AI for any illegal,
                  harmful, or abusive purposes.
                  <br />- We reserve the right to modify, suspend, or
                  discontinue our services at any time.
                </Text>
                <Text>
                  <strong>2. User Accounts</strong>
                  <br />- You may need to create an account to access certain
                  features.
                  <br />- You are responsible for maintaining the security of
                  your account.
                  <br />- Any activity under your account is your
                  responsibility.
                </Text>
                <Text>
                  <strong>3. Privacy Policy</strong>
                  <br />- Your use of Tellos AI is also governed by our Privacy
                  Policy, which outlines how we collect, store, and use your
                  data.
                </Text>
                <Text>
                  <strong>4. Content Ownership</strong>
                  <br />- Any content generated by Tellos AI is provided "as
                  is."
                  <br />- You retain ownership of any original content you
                  input, but Tellos AI retains the right to use, modify, or
                  improve its models based on anonymized usage data.
                </Text>
                <Text>
                  <strong>5. Limitation of Liability</strong>
                  <br />- We do not guarantee uninterrupted or error-free
                  service.
                  <br />- We are not liable for any indirect, incidental, or
                  consequential damages arising from your use of Tellos AI.
                </Text>
                <Text>
                  <strong>6. Changes to Terms</strong>
                  <br />- We may update these Terms at any time. Continued use
                  of Tellos AI after updates constitutes acceptance of the new
                  Terms.
                </Text>
                <Text>
                  <strong>7. Governing Law</strong>
                  <br />- These Terms are governed by and construed in
                  accordance with the laws of Australia.
                  <br />- Any disputes arising from these Terms shall be subject
                  to the exclusive jurisdiction of Australian courts.
                </Text>

                <Text>
                  <strong>8. Privacy Policy & Refund Policy</strong>
                  <br />- Your use of Tellos AI is also governed by our{" "}
                  <strong>Privacy Policy</strong>, which outlines how we
                  collect, store, and use your data.
                  <br />- We have a separate <strong>Refund Policy</strong> that
                  details the conditions under which refunds may be granted.
                </Text>

                <Text>
                  <strong>9. Contact Us</strong>
                  <br />- For any questions regarding these Terms, please
                  contact us at smartaipodcast@gmail.com.
                </Text>
                <Text>
                  By using Tellos AI, you acknowledge that you have read,
                  understood, and agreed to these Terms.
                </Text>
              </Flex>

              <Flex gap="3" mt="4" justify="end">
                <Dialog.Close>
                  <Button style={{ cursor: "pointer" }}>I Agree</Button>
                </Dialog.Close>
              </Flex>
            </Dialog.Content>
          </Dialog.Root>

          {/* Privacy Policy  */}
          <Dialog.Root>
            <Dialog.Trigger>
              <Link
                variant="ghost"
                style={{ color: "white", cursor: "pointer" }}
              >
                Privacy Policy
              </Link>
            </Dialog.Trigger>

            <Dialog.Content maxWidth="950px">
              <Dialog.Title>Privacy Policy of Tellos AI</Dialog.Title>

              <Flex direction="column" gap="3">
                <Text>Last Updated: February 27, 2025</Text>
                <Text>
                  Welcome to Tellos AI! Your privacy is important to us. This
                  Privacy Policy explains how we collect, use, and protect your
                  information when you use our services.
                </Text>
                <Text>
                  <strong>1. Information We Collect</strong>
                  <br />- <strong>Personal Information:</strong> We may collect
                  your name, email address, payment details, and other relevant
                  information when you sign up or use our services.
                  <br />- <strong>Usage Data:</strong> We collect information
                  about how you interact with Tellos AI, including log data,
                  device information, and IP addresses.
                  <br />- <strong>Cookies & Tracking:</strong> We use cookies
                  and similar tracking technologies to improve user experience
                  and analyze website performance.
                </Text>
                <Text>
                  <strong>2. How We Use Your Information</strong>
                  <br />- To provide, maintain, and improve our services.
                  <br />- To communicate with you regarding updates, support,
                  and promotional content (you can opt out of marketing emails
                  at any time).
                  <br />- To ensure security, prevent fraud, and comply with
                  legal obligations.
                </Text>
                <Text>
                  <strong>3. Data Sharing & Third Parties</strong>
                  <br />- We do not sell your personal data.
                  <br />- We may share your data with trusted third-party
                  service providers for payment processing, analytics, and
                  customer support.
                  <br />- We may disclose data if required by law or to protect
                  our rights and users.
                </Text>
                <Text>
                  <strong>4. Data Security</strong>
                  <br />- We use industry-standard security measures to protect
                  your data.
                  <br />- Despite our efforts, no online service is 100% secure;
                  use our services at your own risk.
                </Text>
                <Text>
                  <strong>5. Data Retention</strong>
                  <br />- We retain your information as long as necessary to
                  provide services or comply with legal obligations.
                  <br />- You can request deletion of your data by contacting
                  us.
                </Text>
                <Text>
                  <strong>6. Your Rights</strong>
                  <br />- You have the right to access, correct, or delete your
                  personal data.
                  <br />- You can manage cookie preferences and opt out of
                  marketing communications.
                </Text>
                <Text>
                  <strong>7. International Data Transfers</strong>
                  <br />- If you are outside Australia, your data may be
                  transferred and processed in other countries with different
                  data protection laws.
                </Text>
                <Text>
                  <strong>8. Changes to This Policy</strong>
                  <br />- We may update this Privacy Policy from time to time.
                  We will notify users of significant changes.
                </Text>
                <Text>
                  <strong>9. Contact Us</strong>
                  <br />
                  For any questions about this Privacy Policy, contact us at
                  smartaipodcast@gmail.com.
                </Text>
                <Text>
                  By using Tellos AI, you acknowledge that you have read,
                  understood, and agreed to this Privacy Policy.
                </Text>
              </Flex>

              <Flex gap="3" mt="4" justify="end">
                <Dialog.Close>
                  <Button style={{ cursor: "pointer" }}>I Agree</Button>
                </Dialog.Close>
              </Flex>
            </Dialog.Content>
          </Dialog.Root>

          {/* Refund policy  */}
          <Dialog.Root>
            <Dialog.Trigger>
              <Link
                variant="ghost"
                style={{ color: "white", cursor: "pointer" }}
              >
                Refund Policy
              </Link>
            </Dialog.Trigger>

            <Dialog.Content maxWidth="950px">
              <Dialog.Title> Terms of Service</Dialog.Title>
              {/* <Dialog.Description size="2" mb="4">
                Here is a general Terms of Service document for a "Pay As You
                Go" app called Tellos AI. Please note that this is a template
                and should be reviewed and customized by a legal professional to
                ensure it complies with your jurisdiction and specific needs.
              </Dialog.Description> */}

              <Flex direction="column" gap="3">
                <Text>Last Updated: February 27, 2025</Text>
                <Text>
                  At Tellos AI, we strive to provide high-quality AI-generated
                  audio services. Please review our refund policy before making
                  a purchase.
                </Text>
                <Text>
                  <strong>1. No Refunds for Used Tokens</strong>
                  <br />- Once tokens have been used to generate audio, they are
                  non-refundable.
                  <br />- We do not offer refunds for partially used or fully
                  consumed tokens.
                </Text>
                <Text>
                  <strong>2. Eligible Refunds</strong>
                  <br />- A refund may only be issued if the audio file is not
                  generated due to a system error.
                  <br />- If the generated audio file is corrupted or unusable,
                  you may request a refund.
                </Text>
                <Text>
                  <strong>3. How to Request a Refund</strong>
                  <br />- If you meet the refund criteria, contact our support
                  team at smartaipodcast@gmail.com within 7 days of your
                  purchase.
                  <br />- Please provide relevant details, including your
                  transaction ID and any error messages received.
                </Text>
                <Text>
                  <strong>4. Refund Processing</strong>
                  <br />- Approved refunds will be processed within 5-10
                  business days.
                  <br />- Refunds will be credited to the original payment
                  method.
                </Text>
                <Text>
                  By purchasing and using Tellos AI tokens, you agree to this
                  Refund Policy.
                </Text>
              </Flex>

              <Flex gap="3" mt="4" justify="end">
                <Dialog.Close>
                  <Button style={{ cursor: "pointer" }}>I Agree</Button>
                </Dialog.Close>
              </Flex>
            </Dialog.Content>
          </Dialog.Root>
        </Flex>

        {/* Right Section */}
        <Flex align="center" gap="5">
          <a
            href="mailto:smartaipodcast@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <EnvelopeClosedIcon
              style={{
                marginTop: "0.5em",
                cursor: "pointer",
                color: "#009951",
              }}
              height="20px"
              width="20px"
            />
          </a>

          <a
            href="https://discord.gg/BCVeXyEyUk"
            target="_blank"
            rel="noopener noreferrer"
          >
            <DiscordLogoIcon
              style={{
                marginTop: "0.5em",
                cursor: "pointer",
                color: "#009951",
              }}
              height="20px"
              width="20px"
            />
          </a>

          <a
            href="https://x.com/tellosai"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              style={{ paddingTop: "5px" }}
              src="/assets/icons/x_logo.svg"
              alt="x logo"
            />
          </a>

          <a
            href="https://www.instagram.com/tellosai/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramLogoIcon
              style={{
                marginTop: "0.5em",
                cursor: "pointer",
                color: "#009951",
              }}
              height="20px"
              width="20px"
            />
          </a>

          <a
            href="https://www.tiktok.com/@tellosai"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              style={{ paddingTop: "5px" }}
              src="/assets/icons/tiktok.svg"
              alt="tiktok logo"
            />
          </a>
        </Flex>
      </Flex>

      <div style={styles.copyRight}>
        <Text size="1">© 2025 Tellos AI. All rights reserved.</Text>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: "black",
    color: "white",
    padding: "20px 10px",
    fontSize: "14px",
  },
  flexContainer: {
    maxWidth: "1200px",
    margin: "0 auto",
    flexWrap: "wrap",
  },
  copyRight: {
    textAlign: "center",
    marginTop: "10px",
    color: "#a1a1a1",
  },
};

export default Footer;
